<div class="wrapper">
  <h3>{{ name | translate }}</h3>
  <ix-cpu-core-bar class="bar" [hideUsage]="true"></ix-cpu-core-bar>
</div>
